export const fiatCurrencyList = [
    { value: "PEN", name: "PEN" },
    { value: "USD", name: "USD" },
  ]